@import '~style-sheet-helpers/core.less';

.key-text {
  .truncate();
  display: inline-block;
  max-width: 100%;
}
